'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


exports.MenuBottomSheet = MenuBottomSheet;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/core/styles');

var _List = require('@material-ui/core/List');

var _List2 = _interopRequireDefault(_List);

var _ListItem = require('@material-ui/core/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Search = require('@material-ui/icons/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Cancel = require('@material-ui/icons/Cancel');

var _Cancel2 = _interopRequireDefault(_Cancel);

var _Check = require('@material-ui/icons/Check');

var _Check2 = _interopRequireDefault(_Check);

var _Input = require('../Form/Input');

var _Typography = require('../Typography');

var _Divider = require('../Divider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var useStyles = (0, _styles.makeStyles)({
  container: {
    background: 'var(--onprimary-high-emphasis)',
    padding: '12px 16px 0px'
  },
  form: {
    marginBottom: '8px',
    position: 'relative'
  },
  inputPrefix: {
    color: 'var(--onsurface-inactive)',
    left: '16px',
    position: 'absolute',
    top: '12px',
    zIndex: '1'
  },
  input: {
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
      height: '48px'
    },
    '& .MuiOutlinedInput-input': {
      paddingLeft: '52px'
    },
    '& .MuiInputBase-root': {
      background: 'var(--black-warm-050)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--black-warm-050) !important'
    },
    '& .MuiIconButton-root': {
      marginRight: '6px'
    }
  },
  list: {
    height: 'calc(100vh - 12px - 24px - 48px - 8px)',
    overflowY: 'scroll',
    width: 'calc(100% + 16px)'
  },
  listItem: {
    height: '48px',
    padding: '0px',
    postion: 'relative',
    width: 'calc(100% - 16px)',
    '&:after': {
      background: 'var(--outline)',
      bottom: '0px',
      content: '""',
      height: '1px',
      position: 'absolute',
      width: '100%',
      left: '0px'
    }
  },
  check: {
    color: 'var(--primary-700)',
    marginRight: '16px'
  },
  empty: {
    height: 'calc(100vh - 93px - 23px)',
    paddingTop: '40px',
    textAlign: 'center'
  }
});

function MenuBottomSheet(_ref) {
  var data = _ref.data,
      emptyText = _ref.emptyText,
      emptyTextVariant = _ref.emptyTextVariant,
      id = _ref.id,
      itemProps = _ref.itemProps,
      onChange = _ref.onChange,
      title = _ref.title,
      titleVariant = _ref.titleVariant,
      value = _ref.value;

  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filter = _useState4[0],
      setFilter = _useState4[1];

  var isSearch = search && search !== '';

  var onSearch = function onSearch(_ref2) {
    var target = _ref2.target;

    var newSearch = target.value || '';
    var newFilter = data.filter(function (row) {
      return (row.value || '').toLowerCase().includes(newSearch) || (row.label || '').toLowerCase().includes(newSearch.toLowerCase());
    });

    setSearch(newSearch);
    setFilter(newFilter);
  };

  var onClearSearch = function onClearSearch() {
    setSearch('');
    setFilter(data);
  };

  (0, _react.useEffect)(function () {
    setFilter(data || []);
  }, []);

  return _react2.default.createElement(
    'div',
    { className: classes.container },
    _react2.default.createElement(
      _Typography.Typography,
      { variant: titleVariant, 'data-margin-bottom': '16px' },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: classes.form },
      _react2.default.createElement(_Search2.default, { className: classes.inputPrefix }),
      _react2.default.createElement(_Input.Input, {
        className: classes.input,
        adornmentVariant: isSearch ? 'custom' : null,
        adornmentAction: onClearSearch,
        AdornmentIcon: isSearch ? _Cancel2.default : null,
        placeholder: 'Cari',
        autocomplete: 'off',
        name: 'dssearch-' + id,
        value: search,
        onChange: onSearch
      })
    ),
    filter.length > 0 && _react2.default.createElement(
      _List2.default,
      { className: classes.list },
      filter.map(function (_ref3) {
        var Icon = _ref3.Icon,
            row = _objectWithoutProperties(_ref3, ['Icon']);

        var isSelected = row.value === (value && value.value);
        return _react2.default.createElement(
          _ListItem2.default,
          _extends({
            key: row.value,
            button: true
          }, itemProps, {
            className: classes.listItem,
            onClick: function onClick() {
              return onChange(_extends({}, row, { Icon: Icon }));
            }
          }),
          _react2.default.createElement(
            _Typography.Typography,
            { variant: 'textbody2-reguler' },
            row.label
          ),
          isSelected && _react2.default.createElement(_Check2.default, { className: classes.check })
        );
      })
    ),
    search !== '' && filter.length === 0 && _react2.default.createElement(
      'div',
      { className: classes.empty },
      _react2.default.createElement(
        _Typography.Typography,
        {
          variant: emptyTextVariant,
          'data-color': 'onsurface-medium-emphasis',
          'data-text-align': 'center'
        },
        emptyText
      ),
      _react2.default.createElement(_Divider.Divider, { 'data-margin-top': '32px' })
    )
  );
}

MenuBottomSheet.defaultProps = {
  data: [],
  emptyText: 'Search Not Found',
  emptyTextVariant: 'subtitle2-reguler',
  id: 'example',
  itemProps: {},
  onChange: function onChange() {},
  title: 'Subtitle 1 Medium',
  titleVariant: 'subtitle1-medium',
  value: null
};

MenuBottomSheet.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  emptyText: _propTypes2.default.string,
  emptyTextVariant: _propTypes2.default.string,
  id: _propTypes2.default.string,
  itemProps: _propTypes2.default.shape({}),
  onChange: _propTypes2.default.func,
  title: _propTypes2.default.string,
  titleVariant: _propTypes2.default.string,
  value: _propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  })
};

exports.default = MenuBottomSheet;